var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card-text',[(_vm.showCalculationFullfilment)?_c('ACalculationFullfilment'):_vm._e(),_c('ACalculationCompliance'),(_vm.isVdaAudit)?_c('ACalculationVda'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }